$(function (){
  // console.log('Color Charts Sliding?');//

  let currentChart = document.querySelectorAll('.Color-Chart');//
  // console.log(currentChart);

  let RequestURL = '/ajax/ajax-color-charts.php';
  $('.Chart-Button').on('click', function(){
    let color_brand = $(this).data('brand');
    let color_series = $(this).data('series');
    // console.log(color_brand + ' Button Clicked');
    // console.log(color_series + ' Button Clicked');

    // $('ul.Color-Chart>li').remove();
    $('ul.Color-Chart>li').slideUp('slow', function () {
      $(this).remove();
    });

    $.ajax({
      type: 'GET',
      url: RequestURL,
      dataType: "json",
      data:{
        color_brand : color_brand,
        color_series : color_series
      },
      beforeSend : function(){console.log('Ajax work started for Color Charts')},
      success:function(data){
        // console.log(data);

        $.each(data, function (i, color) {
          // console.log(color);

          $('ul.Color-Chart').append([
            $('<li>',{ "class": color.cssClass }).attr({style: function() {
              if(color.gradient) {
                return color.gradient
              } else {
                return `background-color: ${color.rgb};`
              }
            }}).append(
                $('<i>', {
                  class: `icon-${color.brand}Logo`,
            }).css({
                  'color': color.textColor
                }),
                $('<a>', {
                  text: `${color.series} ${color.name} ${color.code}`
                }).css({
              'color': color.textColor
            })).qtip({
              content: {
                title: `${color.brand} ${color.series} ${color.name} ${color.code}`,
                 text: `<li>${color.durability} durability.</li>` +
                       `<li>${color.thickness} ${color.colorType} material</li>` +
                       `<li>Suitable for ${color.conformability}</li>`
              },
              style: {
                classes: 'qtip-dark qtip-rounded qtip-shadow'
              }
            })
          ]); //$('#Color-Chart').append([ END
          $('div.Color-Chart').hide().slideDown('slow');
        }) // $.each(data, function (i, color) { END
      } // success:function(data){ END
    }); // $.ajax({ END
  }); // $('.Chart-Button').on('click', function(){ END

}); // $(function (){ END